import { useLingui } from '@lingui/react';
import { Select, MenuItem } from '@material-ui/core';
import { useCallback } from 'react';
import { dynamicActivate, locales, LANGUAGE_STORAGE_KEY } from '../../i18n';
import styles from './SelectLanguage.module.css';

export const SelectLanguage = () => {
    const { i18n } = useLingui();
    const handleLocaleChange = useCallback(e => {
        const locale = e.target.value;

        dynamicActivate(locale);

        try {
            localStorage.setItem(LANGUAGE_STORAGE_KEY, locale);
        } catch (err) {
            console.error('Could not save locale to localStorage');
        }
    }, []);

    return (
        <Select
            className={styles.select}
            value={i18n.locale}
            onChange={handleLocaleChange}
        >
            {Object.values(locales).map(locale => (
                <MenuItem
                    key={locale}
                    value={locale}
                >
                    {locale}
                </MenuItem>
            ))}
        </Select>
    );
};
